import { graphql } from "react-apollo";
import { FlightScheduleImportsConnection } from "../../../queries/FlightScheduleImportsConnection";
import mapConnection from "../../../utils/connectionMapper";
import { paginationVariables } from "../../../utils/pagination";

const withFlightImportsData = graphql(FlightScheduleImportsConnection, {
  options: (props) => ({
    variables: {
      ...paginationVariables(props),
      orderBy: [["created_at", "desc"]]
    }
  }),
  props: ({
    data: { flightScheduleImportsConnection, nextFlightScheduleImport }
  }) => ({
    allFlightScheduleImports: mapConnection(flightScheduleImportsConnection),
    nextFlightScheduleImport,
    pageInfo: flightScheduleImportsConnection
      ? flightScheduleImportsConnection.pageInfo
      : {},
    totalCount: flightScheduleImportsConnection
      ? flightScheduleImportsConnection.totalCount
      : 0
  })
});

export default withFlightImportsData;



// WEBPACK FOOTER //
// ./src/component/Maintenance/ImportFlights/withFlightImportsData.js